// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/check_small.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

input[type='checkbox'] {
  --tw-ring-color: #6a6a6a !important;
  border-color: #6a6a6a !important;
}

input[type='checkbox']:focus {
  --tw-ring-color: transparent !important;
}

input[type='checkbox']:checked,
.Mui-checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  color: transparent !important;
  border-color: #0a8bc7 !important;
  border-width: 2px !important;
  border-radius: 2px !important;
  background-repeat: no-repeat !important;
  background-size: 9.35px !important;
  min-height: 15px !important;
  min-width: 15px !important;
  max-width: 15px !important;
  max-height: 15px !important;
  background-position: center center !important;
}

/* 
.MuiCheckbox-indeterminate {
  background-image: url("./assets/images/check_small.svg") !important;
  padding: 0px !important;
}

.MuiCheckbox-indeterminate input[type="checkbox"] {
  width: 5px;
  height: 5px;
} */

.Mui-checked,
.MuiCheckbox-root {
  padding: 0px !important;
  width: 15px !important;
  height: 15px !important;
}

input[type='checkbox']:hover {
  cursor: pointer;
}
/* scrollbar */
.thin-scroller {
  scrollbar-width: thin;
  scrollbar-color: #e5e7eb transparent;
  overflow-y: scroll;
}
.thin-scroller:hover {
  cursor: pointer;
}
.thin-scroller::-webkit-scrollbar {
  width: 6px;
}

.thin-scroller::-webkit-scrollbar-thumb {
  background-color: transparent;
}

/* Invisible scroll */
.invisible-scroller {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.invisible-scroller::-webkit-scrollbar {
  display: none;
}

@keyframes spin-slow {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.animate-spin-slow {
  animation: spin-slow 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,oEAAmE;EACnE,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;;;;;;;;GASG;;AAEH;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;AACA,cAAc;AACd;EACE,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\ninput[type='checkbox'] {\n  --tw-ring-color: #6a6a6a !important;\n  border-color: #6a6a6a !important;\n}\n\ninput[type='checkbox']:focus {\n  --tw-ring-color: transparent !important;\n}\n\ninput[type='checkbox']:checked,\n.Mui-checked {\n  background-image: url('./assets/images/check_small.svg') !important;\n  color: transparent !important;\n  border-color: #0a8bc7 !important;\n  border-width: 2px !important;\n  border-radius: 2px !important;\n  background-repeat: no-repeat !important;\n  background-size: 9.35px !important;\n  min-height: 15px !important;\n  min-width: 15px !important;\n  max-width: 15px !important;\n  max-height: 15px !important;\n  background-position: center center !important;\n}\n\n/* \n.MuiCheckbox-indeterminate {\n  background-image: url(\"./assets/images/check_small.svg\") !important;\n  padding: 0px !important;\n}\n\n.MuiCheckbox-indeterminate input[type=\"checkbox\"] {\n  width: 5px;\n  height: 5px;\n} */\n\n.Mui-checked,\n.MuiCheckbox-root {\n  padding: 0px !important;\n  width: 15px !important;\n  height: 15px !important;\n}\n\ninput[type='checkbox']:hover {\n  cursor: pointer;\n}\n/* scrollbar */\n.thin-scroller {\n  scrollbar-width: thin;\n  scrollbar-color: #e5e7eb transparent;\n  overflow-y: scroll;\n}\n.thin-scroller:hover {\n  cursor: pointer;\n}\n.thin-scroller::-webkit-scrollbar {\n  width: 6px;\n}\n\n.thin-scroller::-webkit-scrollbar-thumb {\n  background-color: transparent;\n}\n\n/* Invisible scroll */\n.invisible-scroller {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.invisible-scroller::-webkit-scrollbar {\n  display: none;\n}\n\n@keyframes spin-slow {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin-slow {\n  animation: spin-slow 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
